import { render, staticRenderFns } from "./view-home.vue?vue&type=template&id=3ad72200&scoped=true&"
import script from "./view-home.vue?vue&type=script&lang=js&"
export * from "./view-home.vue?vue&type=script&lang=js&"
import style0 from "./view-home.vue?vue&type=style&index=0&id=3ad72200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad72200",
  null
  
)

export default component.exports